import DummyCard from './DummyCard';

export default DummyCard;
